import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ApiService } from "../../components/API/ApiService";
import FormesCanvas from "./FormesCanvas";
import { useAuth } from "../../components/context/AuthContext";


function MurDeBrique() {
  const { murId } = useParams();
  const navigate = useNavigate();
  const [mur, setMur] = useState(null);
  const [formesDetails, setFormesDetails] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { getApiBaseUrl } = useAuth();
  const api = ApiService(getApiBaseUrl());

  // Récupère les détails des formes
  useEffect(() => {
    console.log(api);
    api.getFormesDisponibles()
      .then(setFormesDetails)
      .catch((err) => {
        console.error("Erreur API Formes:", err);
        setError(err.message);
        setLoading(false);
      });
  }, []);

  // Récupère les infos du mur
  useEffect(() => {
    if (!murId || formesDetails.length === 0) return;

    api.getMurById(murId)
      .then((data) => {
        console.log("Données reçues du mur :", data);

        const briquesAvecDetails = data.briques.map((brique) => {
          const details = formesDetails.find((f) => f.id === brique.formId);
          if (!details) {
            console.warn(`Aucun détail trouvé pour la forme ID ${brique.formId}`);
          }
          return { ...brique, ...details };
        });

        setMur({ ...data, briques: briquesAvecDetails });
        setLoading(false);
      })
      .catch((err) => {
        console.error("Erreur API :", err);
        setError(err.message);
        setLoading(false);
      });
  }, [murId, formesDetails]);

  const supprimerLeMur = () => {
    api.deleteMur(murId)
      .then(() => navigate("/"))
      .catch((err) => console.error("Erreur API (suppression mur) :", err));
  };

  if (!murId) return <p>Erreur : Aucun mur sélectionné.</p>;
  if (loading) return <p>Chargement du mur...</p>;
  if (error) return <p>Erreur lors du chargement : {error}</p>;

  return (
    <div className="mur-wrapper">
      <h1>{mur.nom}</h1>
      <div className="canvas-container">
        <div className="canvas-wrapper">
          <FormesCanvas formes={mur.briques} />
        </div>
        <div className="boutons-action">
          <button onClick={() => navigate(`/modifier-mur/${murId}`)}>
            &#128736; Modifier le mur
          </button>
          <button
            onClick={() => {
              if (window.confirm("Supprimer définitivement ce mur ?")) {
                supprimerLeMur();
              }
            }}
          >
            &#128465; Supprimer le mur
          </button>
          <button onClick={() => navigate(`/jouer/${murId}`)}>
            &#127918; Jouer ce niveau
          </button>
        </div>
      </div>
    </div>
  );
}

export default MurDeBrique;